var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBus = function SvgBus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bus_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.1,
    mask: "url(#bus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.645 4.564v6.595c0 1.164.935 2.11 2.096 2.124a1.716 1.716 0 0 1 3.432 0h5.654a1.716 1.716 0 0 1 3.432 0h.91c.656 0 1.187-.53 1.187-1.185V8.501c0-4.406-1.789-5.239-3.995-5.239H1.947c-.72 0-1.303.583-1.303 1.302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.785 4.506v4.39h1.595c.78 0 1.545.206 2.219.598l1.757 1.024M6.215 8.895h5.57V3.253h-5.57zm-5.57 0h5.57V3.567m5.612 9.717a1.716 1.716 0 1 0 3.432 0 1.716 1.716 0 0 0-3.432 0m-9.086 0za1.716 1.716 0 1 0 3.432 0 1.716 1.716 0 0 0-3.432 0"
  }))));
};
export default SvgBus;